import { humanizeReason } from "./tenancies-tab";

export const ReasonSelector = ({ selectedReason, onReasonSelected }) => {

    const defaultReason = { reason: "new", icon: "fa-plus" };

    const reasons = [
        defaultReason,
        { reason: "move", icon: "fa-home" },
        { reason: "rentChange", icon: "fa-chevron-up" }
    ];

    const convertReason = () => reasons.find(r => r.reason === selectedReason);
    const getReason = reason => {
        const result = !!reason ? humanizeReason(reason.reason) : defaultReason.reason;
        return result;
    };

    return (

        <div className="mb-3 d-md-flex fw-bold">
            <div className="dropdown-toggle">
                <div style={{ cursor: "pointer" }} data-bs-toggle="dropdown" className="text-decoration-none text-dark"><i className={`fa ${(convertReason() ?? defaultReason).icon} fa-fw text-dark text-opacity-50 me-1`}></i> {getReason(convertReason(selectedReason) ?? defaultReason)} <b className="ms-5px caret"></b></div>
                <div className="dropdown-menu dropdown-menu-start">
                    {reasons.map((reason, i) => ( // For each type...
                        <div onClick={() => onReasonSelected(reason.reason)} style={{ cursor: "pointer" }} key={i} className="dropdown-item"><i className={`fa ${reason.icon} fa-fw fa-lg text-gray-500 me-1`}></i>{getReason(reason)}</div>
                    ))}
                </div>
            </div>
        </div>
    );
};